import MStatic from 'mithril/hyperscript';

export const m = MStatic;
